import gsap from "gsap"
import { useGSAP } from "@gsap/react"
import TextPlugin from "gsap/TextPlugin"
import { Draggable } from "gsap/Draggable"
import { SplitText } from "gsap/SplitText"
import { FC, PropsWithChildren } from "react"
import DrawSVGPlugin from "gsap/DrawSVGPlugin"
import MorphSVGPlugin from "gsap/MorphSVGPlugin"
import { ScrollTrigger } from "gsap/ScrollTrigger"
import MotionPathPlugin from "gsap/MotionPathPlugin"

gsap.registerPlugin(
  Draggable,
  MotionPathPlugin,
  DrawSVGPlugin,
  MorphSVGPlugin,
  SplitText,
  TextPlugin
)

export const WithGsap: FC<PropsWithChildren> = ({ children }) => {
  useGSAP(() => {
    gsap.config({
      nullTargetWarn: false
    })

    gsap.defaults({
      ease: "power2.inOut",
      duration: 1
    })

    gsap.delayedCall(1, () => {
      ScrollTrigger.refresh()
    })
  }, [])

  return <>{children}</>
}
